// Exports
export default {
	"ConferenceHistoryPage": "ConferenceHistoryPage_BT9LD",
	"oneColLayout": "oneColLayout_ZSOny",
	"stub": "stub_ip8dL",
	"telemostDesktopIntegration": "telemostDesktopIntegration_S9TpN",
	"wrapper": "wrapper_wbT1r",
	"left": "left_Ojoiz",
	"right": "right_r1R1r"
};
